(function () {
  const root = document.getElementById("product-options-manager");

  if (!root) return;

  if (root.dataset.pomLoaded === "true") return;
  root.dataset.pomLoaded = "true";

  const productGid = root.dataset.productGid;
  const productHandle = root.dataset.productHandle;
  const basePrice = Number(root.dataset.basePrice || 0) / 100;

  const selectedOptions = {};
  const selectedPrices = {};
  const variationPriceRows = [];
  const nativeVariantData = readNativeVariantData();
  const VARIATION_PRICE_FIELD_TYPE = "__variation_prices";
  const LEGACY_VARIATION_PRICE_TYPE = "variation_price";

  let selectedQuantity = 1;
  let optionsLoaded = false;
  let hasOptionGroups = false;
  let currentPricing = {
    hasExactVariationPrice: false,
    finalPrice: null,
    unitPrice: null,
  };

  function readNativeVariantData() {
    const dataElement = document.querySelector(
      "script[data-pom-native-variants]",
    );

    if (!dataElement) return null;

    try {
      const data = JSON.parse(dataElement.textContent || "{}");
      return Array.isArray(data.optionNames) && Array.isArray(data.variants)
        ? data
        : null;
    } catch (error) {
      console.error("Product options variant data is invalid:", error);
      return null;
    }
  }

  function money(amount) {
    return (
      "Rs. " +
      Number(amount).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    );
  }

  function normalizeType(type) {
    return String(type || "")
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "_")
      .replace(/-/g, "_");
  }

  function getValues(field) {
    return field.config?.values || field.config?.options || [];
  }

  function getChoiceValue(item, index = 0) {
    if (!item || typeof item !== "object") {
      return String(item ?? "").trim();
    }

    const value = firstNonBlank(
      item.value,
      item.text,
      item.label,
      item.name,
      item.title,
      item.color,
      item.hex,
      item.swatch,
      item.image,
      item.src,
      item.url,
      item.thumbnail,
      item.preview,
    );

    if (value) return value;

    const hasConfiguredValue = [
      item.color,
      item.hex,
      item.swatch,
      item.image,
      item.src,
      item.url,
      item.thumbnail,
      item.preview,
    ].some((candidate) => String(candidate ?? "").trim());

    return hasConfiguredValue ? `option-${index + 1}` : "";
  }

  function firstNonBlank(...values) {
    return (
      values
        .map((value) => String(value ?? "").trim())
        .find((value) => value.length > 0) || ""
    );
  }

  function getChoiceLabel(item, value) {
    if (!item || typeof item !== "object") return String(value || "").trim();

    return String(
      item.text ||
        item.label ||
        item.name ||
        item.title ||
        item.value ||
        item.color ||
        item.hex ||
        item.swatch ||
        value ||
        "Option",
    ).trim();
  }

  function getOptionPrice() {
    return 0;
  }

  function getAdvancedHelp(field) {
    return (
      // Support various legacy field shapes
      field?.advancedHelp ||
      field?.advanced_help ||
      field?.["advanced-help"] ||
      field?.helpText ||
      field?.help_text ||
      field?.help ||
      // Common nested locations
      field?.config?.advancedHelp ||
      field?.config?.advanced_help ||
      field?.config?.["advanced-help"] ||
      field?.config?.helpText ||
      field?.config?.help_text ||
      field?.config?.help ||
      // Actual admin editor stores: field.config.advanced.help
      field?.config?.advanced?.help ||
      field?.config?.advanced?.helpText ||
      field?.config?.advanced?.help_text ||
      field?.config?.advanced?.["advanced-help"] ||
      // Sometimes advanced is stored at field.config.advanced
      field?.advanced?.help ||
      field?.advanced?.helpText ||
      field?.advanced?.help_text ||
      field?.advanced?.["advanced-help"] ||
      ""
    );
  }

  function appendAdvancedHelp(parent, field) {
    const helpTextRaw = getAdvancedHelp(field);
    const helpText = String(helpTextRaw || "").trim();

    if (!helpText) return;

    const help = document.createElement("div");
    help.className = "pom-advanced-help";
    help.innerHTML = helpText;

    parent.appendChild(help);
  }

  function getProductMediaImage() {
    const activeImage = document.querySelector(
      "media-gallery .product__media-item.is-active .product__media img",
    );

    if (activeImage) return activeImage;

    return document.querySelector(
      "media-gallery .product__media-item .product__media img, .product__media img, .product__media-list img",
    );
  }

  function rememberOriginalProductImage(image) {
    if (!image || image.dataset.pomOriginalSrc) return;

    image.dataset.pomOriginalSrc = image.getAttribute("src") || "";
    image.dataset.pomOriginalSrcset = image.getAttribute("srcset") || "";
    image.dataset.pomOriginalSizes = image.getAttribute("sizes") || "";
  }

  function setProductMediaImage(imageUrl) {
    const image = getProductMediaImage();

    if (!image || !imageUrl) return;

    rememberOriginalProductImage(image);

    image.removeAttribute("srcset");
    image.src = imageUrl;

    const modalOpener = image.closest(".product__modal-opener");
    const zoomButton = modalOpener?.querySelector(".product__media-toggle");

    if (zoomButton) {
      zoomButton.dataset.pomSwatchImage = imageUrl;
    }
  }

  function restoreProductMediaImage() {
    const image = getProductMediaImage();

    if (!image?.dataset.pomOriginalSrc) return;

    image.src = image.dataset.pomOriginalSrc;

    if (image.dataset.pomOriginalSrcset) {
      image.setAttribute("srcset", image.dataset.pomOriginalSrcset);
    }

    if (image.dataset.pomOriginalSizes) {
      image.setAttribute("sizes", image.dataset.pomOriginalSizes);
    }
  }

  function updatePrice() {
    const addonTotal = Object.values(selectedPrices).reduce(
      (sum, price) => sum + Number(price || 0),
      0,
    );

    const qty = Math.max(1, Number(selectedQuantity || 1));
    const matchedVariationPrice = findMatchingVariationPrice();
    const hasExactVariationPrice = matchedVariationPrice !== null;
    let total = matchedVariationPrice;

    if (!hasExactVariationPrice) {
      const unitPrice = basePrice + addonTotal;
      total = unitPrice * qty;
    }

    currentPricing = {
      hasExactVariationPrice,
      finalPrice: Number(Number(total || 0).toFixed(2)),
      unitPrice: Number(Number(total / qty || 0).toFixed(2)),
    };
    syncAllCartFormsNativeVariant();
    syncAllCartFormsQuantity();
    syncAllCartFormsVariationPriceProperties();
    showPricingError();

    document
      .querySelectorAll(
        ".price-item--regular, .price-item--sale, .product__price, [data-product-price]",
      )
      .forEach((el) => {
        el.textContent = money(total);
      });

    const groups = root.querySelectorAll(".pom-group");
    const priceParent = groups.length ? groups[groups.length - 1] : root;

    let totalBox = root.querySelector(".pom-total-price");

    if (!totalBox) {
      totalBox = document.createElement("div");
      totalBox.className = "pom-total-price";
    }

    // Move total price inside .pom-group
    if (totalBox.parentElement !== priceParent) {
      priceParent.appendChild(totalBox);
    }

    const perPieceText =
      qty > 1
        ? `<span>for ${qty} Qty (${money(total / qty)} / piece)</span>`
        : `<span>for 1 Qty (${money(total / qty)} / piece)</span>`;

    totalBox.innerHTML = `
    <div class="pom-price-box">
      <div class="price">${money(total)}</div>
      <span class="tax-text"> Inc. of All Taxes</span>
      ${perPieceText}
      <span class="bulk-text">Buy in bulk and save</span>
    </div>
  `;
  }

  function findSelectedNativeVariant() {
    if (!nativeVariantData || nativeVariantData.optionNames.length === 0) {
      return null;
    }

    const selectedValues = nativeVariantData.optionNames.map((optionName) =>
      getSelectedOptionValue(optionName),
    );

    if (selectedValues.some((value) => !String(value || "").trim())) {
      return null;
    }

    return (
      nativeVariantData.variants.find(
        (variant) =>
          variant.available !== false &&
          variant.options.length === selectedValues.length &&
          variant.options.every(
            (value, index) =>
              normalizeVariationValue(value) ===
              normalizeVariationValue(selectedValues[index]),
          ),
      ) || null
    );
  }

  function normalizeOptionName(value) {
    return String(value ?? "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ");
  }

  function getSelectedOptionValue(optionName) {
    const normalizedName = normalizeOptionName(optionName);
    const matchedEntry = Object.entries(selectedOptions).find(
      ([name]) => normalizeOptionName(name) === normalizedName,
    );

    return matchedEntry?.[1];
  }

  function syncCartFormNativeVariant(form) {
    const variant = findSelectedNativeVariant();
    if (!variant) return false;

    let inputs = form.querySelectorAll("[name='id']");
    if (!inputs.length) {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "id";
      form.appendChild(input);
      inputs = [input];
    }
    // Write immediately before FormData is built. Theme change listeners can
    // otherwise replace our ID with the product's default variant.
    inputs.forEach((input) => {
      input.disabled = false;
      input.value = String(variant.id);
    });
    return true;
  }

  function getPricingError() {
    if (!optionsLoaded) return "Product options are still loading. Please wait.";
    if (!variationPriceRows.length) return "";
    if (!currentPricing.hasExactVariationPrice) return "Please choose all pricing options.";
    const variant = findSelectedNativeVariant();
    if (!variant) return "This combination is unavailable or has not been synced. Please contact us.";
    const lineCents = Number(variant.price) * Math.max(1, Number(selectedQuantity || 1));
    if (!Number.isFinite(lineCents) || Math.round(lineCents) !== Math.round(currentPricing.finalPrice * 100)) {
      return "This option price needs updating. Please refresh the page or contact us before ordering.";
    }
    return "";
  }

  function showPricingError() {
    let message = root.querySelector(".pom-pricing-error");
    const error = optionsLoaded ? getPricingError() : "";
    if (!error) {
      message?.remove();
      return;
    }
    if (!message) {
      message = document.createElement("p");
      message.className = "pom-pricing-error pom-error";
      message.setAttribute("role", "alert");
      root.appendChild(message);
    }
    message.textContent = error;
  }

  function syncAllCartFormsNativeVariant() {
    document.querySelectorAll("form[action*='/cart/add']").forEach((form) => {
      syncCartFormNativeVariant(form);
    });
  }
  function getFieldKey(field) {
    return String(field.label || field.name || "Option").trim();
  }

  function isVariationPriceStorageField(field) {
    const normalizedType = normalizeType(field?.type);
    const normalizedName = normalizeType(field?.name);
    const normalizedLabel = normalizeType(field?.label);

    return (
      normalizedType === VARIATION_PRICE_FIELD_TYPE ||
      normalizedName === VARIATION_PRICE_FIELD_TYPE ||
      normalizedLabel === VARIATION_PRICE_FIELD_TYPE ||
      normalizeType(field?.config?.storageType) ===
        VARIATION_PRICE_FIELD_TYPE ||
      (normalizedName === "variation_prices" &&
        Array.isArray(field?.config?.prices)) ||
      (normalizedLabel === "variation_prices" &&
        Array.isArray(field?.config?.prices))
    );
  }

  function normalizeVariationPriceRows(value) {
    const rows = Array.isArray(value) ? value : [];

    return rows.map(normalizeVariationPriceRow).filter((row) => row.key);
  }

  function normalizeVariationPriceRow(row = {}) {
    const selections = Array.isArray(row.selections)
      ? row.selections
          .map((selection) => ({
            field: String(selection.field || selection.name || "").trim(),
            value: String(selection.value ?? "").trim(),
          }))
          .filter((selection) => selection.field && selection.value)
      : [];
    const key =
      String(row.key || "") ||
      selections
        .map(
          (selection) =>
            `${encodeURIComponent(selection.field)}=${encodeURIComponent(
              selection.value,
            )}`,
        )
        .join("&");

    return {
      key,
      selections,
      price: row.price === undefined || row.price === null ? "" : row.price,
    };
  }

  function normalizeVariationValue(value) {
    return String(value ?? "")
      .trim()
      .toLowerCase();
  }

  function variationPriceRowMatches(row) {
    return (
      row.selections.length > 0 &&
      row.selections.every(
        (selection) =>
          normalizeVariationValue(getSelectedOptionValue(selection.field)) ===
          normalizeVariationValue(selection.value),
      )
    );
  }

  function findMatchingVariationPrice() {
    const matchedRow = variationPriceRows.find(variationPriceRowMatches);
    const priceValue = String(matchedRow?.price ?? "").trim();

    if (!priceValue) return null;

    const price = Number(priceValue);

    return Number.isFinite(price) ? price : null;
  }

  function findAddToCartButtons() {
    return document.querySelectorAll(
      "[data-add-to-cart-button], form[action*='/cart/add'] button[type='submit'], form[action*='/cart/add'] input[type='submit']",
    );
  }

  function setFieldInvalid(fieldEl, isInvalid) {
    fieldEl.classList.toggle("pom-field--invalid", isInvalid);

    let error = fieldEl.querySelector(".pom-field-error");

    if (!isInvalid) {
      if (error) error.remove();
      return;
    }

    if (!error) {
      error = document.createElement("div");
      error.className = "pom-field-error";
      error.textContent = "This field is required.";
      fieldEl.appendChild(error);
    }
  }

  function getRequiredFieldValue(fieldEl) {
    const fileInput = fieldEl.querySelector("input[type='file']");

    if (fileInput) {
      return fileInput.files?.length ? "selected" : "";
    }

    const checkedInput = fieldEl.querySelector(
      "input[type='checkbox']:checked, input[type='radio']:checked",
    );

    if (checkedInput) return checkedInput.value;

    const input = fieldEl.querySelector("select, textarea, input");

    return input?.value || "";
  }

  function validateRequiredFields({ showErrors = false } = {}) {
    const requiredFields = root.querySelectorAll(
      ".pom-field[data-pom-required='true']",
    );
    let firstInvalid = null;
    let allFilled = true;

    requiredFields.forEach((fieldEl) => {
      const value = String(getRequiredFieldValue(fieldEl) || "").trim();
      const isInvalid = !value || value === "Required";

      if (isInvalid) {
        allFilled = false;
        if (!firstInvalid) firstInvalid = fieldEl;
      }

      setFieldInvalid(fieldEl, showErrors && isInvalid);
    });

    const ready = allFilled && !getPricingError();
    findAddToCartButtons().forEach((button) => {
      button.disabled = !ready;
      button.setAttribute("aria-disabled", String(!ready));
    });

    if (showErrors && firstInvalid) {
      firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
      firstInvalid.querySelector("input, select, textarea, button")?.focus();
    }

    return ready;
  }

  function saveSelection(field, value) {
    const key = getFieldKey(field);
    const cleanValue = String(value ?? "");

    if (cleanValue) {
      selectedOptions[key] = cleanValue;
      selectedPrices[key] = getOptionPrice(field, cleanValue);
    } else {
      delete selectedOptions[key];
      delete selectedPrices[key];
    }

    updatePrice();
    validateRequiredFields();
  }

  function removeProductDesignOverlay() {
    document.querySelectorAll(".pom-design-overlay").forEach((el) => {
      el.remove();
    });

    document.querySelectorAll(".pom-preview-position-input").forEach((el) => {
      el.remove();
    });

    document.querySelectorAll(".pom-merged-preview-file").forEach((el) => {
      el.remove();
    });
  }

  function findMainProductImageWrapper() {
    return (
      document
        .querySelector(".product__media img")
        ?.closest(".product__media") ||
      document
        .querySelector(".product__media-item img")
        ?.closest(".product__media-item") ||
      document
        .querySelector(".product-media-container img")
        ?.closest(".product-media-container") ||
      document.querySelector("media-gallery img")?.closest("media-gallery") ||
      document.querySelector(".product__media-wrapper")
    );
  }

  function getMainProductImageElement() {
    return (
      document.querySelector(".product__media img") ||
      document.querySelector(".product__media-item img") ||
      document.querySelector(".product-media-container img") ||
      document.querySelector("media-gallery img")
    );
  }

  function saveOverlayPositionToCart(overlay) {
    const form = document.querySelector("form[action*='/cart/add']");
    const wrapper = overlay?.parentElement;

    if (!form || !overlay || !wrapper) return;

    const wrapperRect = wrapper.getBoundingClientRect();
    const overlayRect = overlay.getBoundingClientRect();

    const x = ((overlayRect.left - wrapperRect.left) / wrapperRect.width) * 100;
    const y = ((overlayRect.top - wrapperRect.top) / wrapperRect.height) * 100;
    const width = (overlayRect.width / wrapperRect.width) * 100;
    const height = (overlayRect.height / wrapperRect.height) * 100;

    const positionData = {
      x: Number(x.toFixed(2)),
      y: Number(y.toFixed(2)),
      width: Number(width.toFixed(2)),
      height: Number(height.toFixed(2)),
    };

    function setHiddenInput(name, value) {
      let input = form.querySelector(`input[name="properties[${name}]"]`);

      if (!input) {
        input = document.createElement("input");
        input.type = "hidden";
        input.className = "pom-preview-position-input";
        input.name = `properties[${name}]`;
        form.appendChild(input);
      }

      input.value = value;
    }

    setHiddenInput("_Preview X", positionData.x);
    setHiddenInput("_Preview Y", positionData.y);
    setHiddenInput("_Preview Width", positionData.width);
    setHiddenInput("_Preview Height", positionData.height);

    setHiddenInput(
      "_Upload preview position JSON",
      JSON.stringify(positionData),
    );
  }

  function loadImageForCanvas(src) {
    return new Promise((resolve, reject) => {
      const img = new Image();

      img.crossOrigin = "anonymous";

      img.onload = () => resolve(img);
      img.onerror = reject;

      img.src = src;
    });
  }

  async function createMergedPreviewFile() {
    const productImageEl = getMainProductImageElement();
    const overlay = document.querySelector(".pom-design-overlay");
    const overlayImageEl = overlay?.querySelector("img");

    if (!productImageEl || !overlay || !overlayImageEl) {
      return null;
    }

    const productImageSrc =
      productImageEl.currentSrc ||
      productImageEl.src ||
      productImageEl.getAttribute("src");

    const overlayImageSrc = overlayImageEl.src;

    if (!productImageSrc || !overlayImageSrc) {
      return null;
    }

    const productImage = await loadImageForCanvas(productImageSrc);
    const uploadedImage = await loadImageForCanvas(overlayImageSrc);

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    if (!ctx) return null;

    const canvasWidth = productImage.naturalWidth || productImage.width;
    const canvasHeight = productImage.naturalHeight || productImage.height;

    canvas.width = canvasWidth;
    canvas.height = canvasHeight;

    ctx.drawImage(productImage, 0, 0, canvasWidth, canvasHeight);

    const wrapper = overlay.parentElement;
    const wrapperRect = wrapper.getBoundingClientRect();
    const overlayRect = overlay.getBoundingClientRect();

    const xPercent =
      ((overlayRect.left - wrapperRect.left) / wrapperRect.width) * 100;
    const yPercent =
      ((overlayRect.top - wrapperRect.top) / wrapperRect.height) * 100;
    const widthPercent = (overlayRect.width / wrapperRect.width) * 100;
    const heightPercent = (overlayRect.height / wrapperRect.height) * 100;

    const drawX = (xPercent / 100) * canvasWidth;
    const drawY = (yPercent / 100) * canvasHeight;
    const drawWidth = (widthPercent / 100) * canvasWidth;
    const drawHeight = (heightPercent / 100) * canvasHeight;

    ctx.drawImage(uploadedImage, drawX, drawY, drawWidth, drawHeight);

    const blob = await new Promise((resolve) => {
      canvas.toBlob(resolve, "image/png", 0.95);
    });

    if (!blob) return null;

    return new File([blob], "product-preview.png", {
      type: "image/png",
    });
  }

  function setFileInputFile(input, file) {
    const dataTransfer = new DataTransfer();

    dataTransfer.items.add(file);
    input.files = dataTransfer.files;
  }

  async function attachMergedPreviewImageToForm(form) {
    const mergedFile = await createMergedPreviewFile();

    if (!mergedFile) return;

    let previewInput = form.querySelector(
      'input[name="properties[Preview image]"]',
    );

    if (!previewInput) {
      previewInput = document.createElement("input");
      previewInput.type = "file";
      previewInput.name = "properties[Preview image]";
      previewInput.className = "pom-merged-preview-file";
      previewInput.style.display = "none";
      form.appendChild(previewInput);
    }

    setFileInputFile(previewInput, mergedFile);
  }

  function makeOverlayMoveableAndResizable(overlay) {
    let isDragging = false;
    let isResizing = false;
    let startX = 0;
    let startY = 0;
    let startLeft = 0;
    let startTop = 0;
    let startWidth = 0;
    let startHeight = 0;
    let activeHandle = null;

    const wrapper = overlay.parentElement;

    function getClientPosition(event) {
      const touch = event.touches?.[0] || event.changedTouches?.[0];

      return {
        x: touch ? touch.clientX : event.clientX,
        y: touch ? touch.clientY : event.clientY,
      };
    }

    function startDrag(event) {
      if (event.target.closest(".pom-design-resize-handle")) return;
      if (event.target.closest(".pom-design-overlay-remove")) return;

      event.preventDefault();

      const pos = getClientPosition(event);
      const rect = overlay.getBoundingClientRect();
      const wrapperRect = wrapper.getBoundingClientRect();

      isDragging = true;
      startX = pos.x;
      startY = pos.y;
      startLeft = rect.left - wrapperRect.left;
      startTop = rect.top - wrapperRect.top;

      overlay.classList.add("is-moving");
    }

    function startResize(event) {
      event.preventDefault();
      event.stopPropagation();

      const pos = getClientPosition(event);
      const rect = overlay.getBoundingClientRect();
      const wrapperRect = wrapper.getBoundingClientRect();

      isResizing = true;
      activeHandle = event.target.dataset.handle;

      startX = pos.x;
      startY = pos.y;
      startLeft = rect.left - wrapperRect.left;
      startTop = rect.top - wrapperRect.top;
      startWidth = rect.width;
      startHeight = rect.height;

      overlay.classList.add("is-moving");
    }

    function onMove(event) {
      if (!isDragging && !isResizing) return;

      event.preventDefault();

      const pos = getClientPosition(event);
      const wrapperRect = wrapper.getBoundingClientRect();

      const dx = pos.x - startX;
      const dy = pos.y - startY;

      if (isDragging) {
        let nextLeft = startLeft + dx;
        let nextTop = startTop + dy;

        nextLeft = Math.max(
          0,
          Math.min(nextLeft, wrapperRect.width - overlay.offsetWidth),
        );

        nextTop = Math.max(
          0,
          Math.min(nextTop, wrapperRect.height - overlay.offsetHeight),
        );

        overlay.style.left = `${(nextLeft / wrapperRect.width) * 100}%`;
        overlay.style.top = `${(nextTop / wrapperRect.height) * 100}%`;
      }

      if (isResizing) {
        let nextLeft = startLeft;
        let nextTop = startTop;
        let nextWidth = startWidth;
        let nextHeight = startHeight;

        if (activeHandle.includes("right")) {
          nextWidth = startWidth + dx;
        }

        if (activeHandle.includes("left")) {
          nextWidth = startWidth - dx;
          nextLeft = startLeft + dx;
        }

        if (activeHandle.includes("bottom")) {
          nextHeight = startHeight + dy;
        }

        if (activeHandle.includes("top")) {
          nextHeight = startHeight - dy;
          nextTop = startTop + dy;
        }

        nextWidth = Math.max(60, nextWidth);
        nextHeight = Math.max(60, nextHeight);

        if (nextLeft < 0) {
          nextWidth += nextLeft;
          nextLeft = 0;
        }

        if (nextTop < 0) {
          nextHeight += nextTop;
          nextTop = 0;
        }

        if (nextLeft + nextWidth > wrapperRect.width) {
          nextWidth = wrapperRect.width - nextLeft;
        }

        if (nextTop + nextHeight > wrapperRect.height) {
          nextHeight = wrapperRect.height - nextTop;
        }

        overlay.style.left = `${(nextLeft / wrapperRect.width) * 100}%`;
        overlay.style.top = `${(nextTop / wrapperRect.height) * 100}%`;
        overlay.style.width = `${(nextWidth / wrapperRect.width) * 100}%`;
        overlay.style.height = `${(nextHeight / wrapperRect.height) * 100}%`;
      }

      saveOverlayPositionToCart(overlay);
    }

    function stopAction() {
      if (!isDragging && !isResizing) return;

      isDragging = false;
      isResizing = false;
      activeHandle = null;

      overlay.classList.remove("is-moving");
      saveOverlayPositionToCart(overlay);
    }

    overlay.addEventListener("mousedown", startDrag);
    overlay.addEventListener("touchstart", startDrag, { passive: false });

    overlay.querySelectorAll(".pom-design-resize-handle").forEach((handle) => {
      handle.addEventListener("mousedown", startResize);
      handle.addEventListener("touchstart", startResize, { passive: false });
    });

    document.addEventListener("mousemove", onMove);
    document.addEventListener("touchmove", onMove, { passive: false });
    document.addEventListener("mouseup", stopAction);
    document.addEventListener("touchend", stopAction);
  }

  function showProductDesignOverlay(imageUrl, fileName) {
    removeProductDesignOverlay();

    const wrapper = findMainProductImageWrapper();

    if (!wrapper) {
      console.warn("Product image wrapper not found.");
      return;
    }

    wrapper.classList.add("pom-overlay-parent");

    const overlay = document.createElement("div");
    overlay.className = "pom-design-overlay";

    overlay.style.left = "34%";
    overlay.style.top = "22%";
    overlay.style.width = "28%";
    overlay.style.height = "28%";

    overlay.innerHTML = `
      <button
        type="button"
        class="pom-design-overlay-remove"
        aria-label="Remove preview"
      >
        ×
      </button>

      <img
        src="${imageUrl}"
        alt="${fileName || "Uploaded design"}"
        draggable="false"
      >

      <span class="pom-design-resize-handle pom-handle-top-left" data-handle="top-left"></span>
      <span class="pom-design-resize-handle pom-handle-top-right" data-handle="top-right"></span>
      <span class="pom-design-resize-handle pom-handle-bottom-left" data-handle="bottom-left"></span>
      <span class="pom-design-resize-handle pom-handle-bottom-right" data-handle="bottom-right"></span>
    `;

    overlay
      .querySelector(".pom-design-overlay-remove")
      .addEventListener("click", () => {
        removeProductDesignOverlay();

        const fileInput = document.querySelector(".pom-file-hidden");

        if (fileInput) {
          fileInput.value = "";
          fileInput.dispatchEvent(new Event("change", { bubbles: true }));
        }

        const fileNameEl = document.querySelector(".pom-upload-file-name");

        if (fileNameEl) {
          fileNameEl.textContent = "";
        }

        validateRequiredFields();
      });

    wrapper.appendChild(overlay);

    makeOverlayMoveableAndResizable(overlay);
    saveOverlayPositionToCart(overlay);
  }

  function renderChoice(field) {
    const type = normalizeType(field.type);
    const values = getValues(field);

    const wrap = document.createElement("div");
    wrap.className = "pom-field";
    wrap.dataset.pomRequired = String(Boolean(field.required));

    const label = document.createElement("label");
    label.className = "pom-label";
    label.textContent = field.label || field.name || "Option";

    wrap.appendChild(label);

    if (type === "dropdown" || type === "select" || type === "font_select") {
      const selectWrap = document.createElement("div");
      selectWrap.className = "pom-buttons";

      const select = document.createElement("select");

      select.className = "pom-select";
      select.name = `properties[${getFieldKey(field)}]`;
      select.required = Boolean(field.required);

      const empty = document.createElement("option");

      empty.value = "";
      empty.textContent = "Select option";

      select.appendChild(empty);

      values.forEach((item, index) => {
        const optionValue = getChoiceValue(item, index);
        const optionLabel = getChoiceLabel(item, optionValue);

        if (!optionValue) return;

        const option = document.createElement("option");

        option.value = optionValue;
        option.textContent = optionLabel || "Option";

        select.appendChild(option);
      });

      select.addEventListener("change", () => {
        saveSelection(field, select.value);
      });

      selectWrap.appendChild(select);
      appendAdvancedHelp(selectWrap, field);

      wrap.appendChild(selectWrap);

      return wrap;
    }

    const buttons = document.createElement("div");
    buttons.className = "pom-buttons";

    const selectedInput = document.createElement("input");

    selectedInput.type = "hidden";
    selectedInput.name = `properties[${getFieldKey(field)}]`;
    selectedInput.value = "";

    wrap.appendChild(selectedInput);

    const isColorField = ["button_swatches", "color_swatches"].includes(type);
    const isColorImageSwatchField = [
      "color_image_swatches",
      "image_swatches",
    ].includes(type);

    function resolveSwatchBackground(item) {
      const candidates = [
        item?.color,
        item?.hex,
        item?.value,
        item?.text,
        item?.swatch,
      ].filter(Boolean);

      const first = candidates[0];
      if (!first) return null;

      const s = String(first).trim();

      if (/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(s)) {
        return s;
      }

      if (/^(rgb|hsl)a?\(/i.test(s)) {
        return s;
      }

      return s || null;
    }

    function isBlobUrl(url) {
      return typeof url === "string" && url.startsWith("blob:");
    }

    values.forEach((item, index) => {
      const optionValue = getChoiceValue(item, index);
      const optionLabel = getChoiceLabel(item, optionValue);

      if (!optionValue) return;

      const button = document.createElement("button");

      button.type = "button";
      button.className = "pom-option-button";

      const swatchBg = isColorField ? resolveSwatchBackground(item) : null;

      let swatchImage = null;

      if (isColorImageSwatchField) {
        swatchImage =
          item?.image ||
          item?.src ||
          item?.url ||
          item?.thumbnail ||
          item?.preview ||
          null;
      }

      if (swatchImage && !isBlobUrl(swatchImage)) {
        button.dataset.pomSwatchImage = swatchImage;
      }

      if (swatchBg) {
        button.style.setProperty("--pom-swatch--background", swatchBg);
        button.classList.add("color-swatche");
      }

      const labelText = optionLabel || "Option";

      if (swatchBg) {
        const swatch = document.createElement("span");
        swatch.className = "pom-swatch-preview";
        swatch.style.background = swatchBg;

        const text = document.createElement("span");
        text.className = "pom-swatch-preview-text";
        text.textContent = labelText;
        swatch.dataset.tooltip = labelText;

        button.innerHTML = "";
        button.appendChild(swatch);
        button.appendChild(text);
      } else if (swatchImage) {
        const swatch = document.createElement("span");
        swatch.className = "pom-swatch-preview";
        swatch.style.background = "transparent";
        button.classList.add("color-swatche");

        const img = document.createElement("img");
        img.src = swatchImage;
        img.alt = labelText;
        img.style.width = "100%";
        img.style.height = "100%";
        img.style.objectFit = "cover";
        img.style.display = "block";
        swatch.appendChild(img);

        const text = document.createElement("span");
        text.className = "pom-swatch-preview-text";
        text.textContent = labelText;
        swatch.dataset.tooltip = labelText;

        button.innerHTML = "";
        button.appendChild(swatch);
        button.appendChild(text);
      } else {
        button.textContent = labelText;
      }

      button.addEventListener("click", () => {
        buttons
          .querySelectorAll(".pom-option-button")
          .forEach((btn) => btn.classList.remove("is-active"));

        button.classList.add("is-active");

        if (swatchBg) {
          button.style.setProperty("--pom-swatch--background", swatchBg);
        }

        if (swatchImage) {
          setProductMediaImage(swatchImage);
        } else if (isColorImageSwatchField) {
          restoreProductMediaImage();
        }

        saveSelection(field, optionValue);

        selectedInput.value = optionValue;
        validateRequiredFields();
      });

      buttons.appendChild(button);
    });

    appendAdvancedHelp(buttons, field);

    wrap.appendChild(buttons);

    return wrap;
  }

  function renderQuantityDiscount(field) {
    const rows = field.config?.rows || field.config?.discounts || [];

    const wrap = document.createElement("div");
    wrap.className = "pom-field";
    wrap.dataset.pomRequired = String(Boolean(field.required));

    const label = document.createElement("label");
    label.className = "pom-label";
    label.textContent = field.label || "Order Quantity";

    wrap.appendChild(label);

    const buttons = document.createElement("div");
    buttons.className = "pom-buttons";

    const selectedInput = document.createElement("input");

    selectedInput.type = "hidden";
    selectedInput.name = `properties[${getFieldKey(field)}]`;
    selectedInput.value = "";

    wrap.appendChild(selectedInput);

    rows.forEach((row) => {
      const qty = Number(row.quantity || row.qty || 0);

      if (!qty) return;

      const button = document.createElement("button");

      button.type = "button";
      button.className = "pom-option-button";
      button.textContent = `${qty}+`;

      button.addEventListener("click", () => {
        buttons
          .querySelectorAll(".pom-option-button")
          .forEach((btn) => btn.classList.remove("is-active"));

        button.classList.add("is-active");

        selectedQuantity = qty;

        const qtyInput =
          document.querySelector("input[name='quantity']") ||
          document.querySelector("quantity-input input");

        if (qtyInput) {
          qtyInput.value = qty;
          qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
          qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
        }

        selectedOptions[getFieldKey(field)] = `${qty}+`;
        selectedInput.value = `${qty}+`;

        updatePrice();
        validateRequiredFields();
      });

      buttons.appendChild(button);
    });

    appendAdvancedHelp(buttons, field);

    wrap.appendChild(buttons);

    return wrap;
  }

  function renderUpload(field) {
    const wrap = document.createElement("div");
    wrap.className = "pom-field pom-upload-field";
    wrap.dataset.pomRequired = String(Boolean(field.required));

    const label = document.createElement("label");
    label.className = "pom-label";
    label.textContent = field.label || "Upload Your Design";

    wrap.appendChild(label);

    const uploadBox = document.createElement("div");
    uploadBox.className = "pom-upload-box";

    uploadBox.innerHTML = `
      <div class="pom-upload">
        <span class="pom-upload-button-text">
          ${field.config?.buttonText || "Upload Your File"}
        </span>
        <span class="pom-upload-file-name"></span>
      </div>
    `;

    const input = document.createElement("input");
    input.type = "file";
    input.className = "pom-file-hidden";
    input.name = `properties[${getFieldKey(field)}]`;
    input.accept = "image/*";
    input.required = Boolean(field.required);

    uploadBox.appendChild(input);
    wrap.appendChild(uploadBox);

    appendAdvancedHelp(uploadBox, field);

    const buttonTextEl = uploadBox.querySelector(".pom-upload-button-text");
    const fileNameEl = uploadBox.querySelector(".pom-upload-file-name");

    const removeButton = document.createElement("button");
    removeButton.type = "button";
    removeButton.className = "pom-upload-remove";
    removeButton.setAttribute("aria-label", "Remove file");
    removeButton.textContent = "×";

    uploadBox.addEventListener("click", () => {
      input.click();
    });

    removeButton.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();

      input.value = "";
      fileNameEl.textContent = "";
      buttonTextEl.style.opacity = "";

      removeButton.remove();

      removeProductDesignOverlay();
      saveSelection(field, "");
    });

    input.addEventListener("change", () => {
      const file = input.files && input.files[0];

      if (!file) {
        fileNameEl.textContent = "";
        buttonTextEl.style.opacity = "";
        removeButton.remove();

        removeProductDesignOverlay();
        saveSelection(field, "");
        return;
      }

      if (!file.type.startsWith("image/")) {
        alert("Please upload an image file.");

        input.value = "";
        fileNameEl.textContent = "";
        buttonTextEl.style.opacity = "";
        removeButton.remove();

        removeProductDesignOverlay();
        saveSelection(field, "");
        return;
      }

      const imageUrl = URL.createObjectURL(file);

      buttonTextEl.style.opacity = "0";
      fileNameEl.textContent = file.name;
      fileNameEl.appendChild(removeButton);

      showProductDesignOverlay(imageUrl, file.name);
      saveSelection(field, file.name);
    });

    return wrap;
  }

  function renderInput(field, inputType) {
    const wrap = document.createElement("div");
    wrap.className = "pom-field";
    wrap.dataset.pomRequired = String(Boolean(field.required));

    const label = document.createElement("label");
    label.className = "pom-label";
    label.textContent = field.label || field.name || "Option";

    wrap.appendChild(label);

    const inputWrap = document.createElement("div");
    inputWrap.className = "pom-buttons";

    const input = document.createElement("input");
    input.type = inputType;
    input.className = "pom-input";
    input.name = `properties[${getFieldKey(field)}]`;
    input.placeholder = field.label || "";
    input.required = Boolean(field.required);

    input.addEventListener("input", () => saveSelection(field, input.value));
    input.addEventListener("change", () => saveSelection(field, input.value));

    inputWrap.appendChild(input);

    appendAdvancedHelp(inputWrap, field);

    wrap.appendChild(inputWrap);

    return wrap;
  }

  function prepareRenderedField(field, fieldEl) {
    if (!fieldEl) return fieldEl;

    fieldEl.dataset.pomRequired = String(Boolean(field.required));
    fieldEl.dataset.pomFieldKey = getFieldKey(field);
    fieldEl.dataset.pomFieldName = field.name || "";
    fieldEl.dataset.pomFieldLabel = field.label || "";

    return fieldEl;
  }

  function renderField(field) {
    const type = normalizeType(field.type);

    if (
      isVariationPriceStorageField(field) ||
      type === LEGACY_VARIATION_PRICE_TYPE
    ) {
      return null;
    }

    const fieldKey = String(getFieldKey(field) || "")
      .trim()
      .toLowerCase();

    const isPincodeField =
      fieldKey === "enter pincode" ||
      fieldKey === "pincode" ||
      fieldKey.includes("pincode");

    function addPincodeClass(fieldEl) {
      if (isPincodeField && fieldEl) {
        fieldEl.classList.add("pincode-pom-field");
      }

      return fieldEl;
    }

    const addToCartButton = document.querySelector("[data-add-to-cart-button]");

    if (addToCartButton) {
      const allFields = document.querySelectorAll(".pom-field");

      if (allFields.length === 0) {
        addToCartButton.disabled = true;
      } else {
        addToCartButton.disabled = false;
      }
    }

    if (
      [
        "radio",
        "checkbox",
        "button_swatches",
        "color_swatches",
        "color_image_swatches",
        "image_swatches",
        "dropdown",
        "select",
        "font_select",
        "personalize",
      ].includes(type)
    ) {
      return prepareRenderedField(field, addPincodeClass(renderChoice(field)));
    }

    if (type === "quantity" || type === "quantity_discount") {
      return prepareRenderedField(
        field,
        addPincodeClass(renderQuantityDiscount(field)),
      );
    }

    if (type === "upload" || type === "upload_lift") {
      return prepareRenderedField(field, addPincodeClass(renderUpload(field)));
    }

    if (type === "number") {
      return prepareRenderedField(
        field,
        addPincodeClass(renderInput(field, "number")),
      );
    }

    if (type === "date") {
      return prepareRenderedField(
        field,
        addPincodeClass(renderInput(field, "date")),
      );
    }

    return prepareRenderedField(
      field,
      addPincodeClass(renderInput(field, "text")),
    );
  }

  function attachToCartForm() {
    document.querySelectorAll("form[action*='/cart/add']").forEach((form) => {
      if (form.dataset.pomSubmitAttached === "true") return;
      form.dataset.pomSubmitAttached = "true";

      form.addEventListener("submit", async (event) => {
        if (optionsLoaded && !hasOptionGroups) return;
        if (!validateRequiredFields({ showErrors: true })) {
          showPricingError();
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }

        const overlay = document.querySelector(".pom-design-overlay");

        Object.entries(selectedOptions).forEach(([key, value]) => {
          let input = form.querySelector(`[name="properties[${key}]"]`);

          if (input?.type === "file") return;

          if (!input) {
            input = document.createElement("input");
            input.type = "hidden";
            input.name = `properties[${key}]`;
            form.appendChild(input);
          }

          input.value = value;
        });

        syncCartFormNativeVariant(form);
        syncVariationPriceProperties(form);
        syncCartFormQuantity(form);
        setCartProperty(form, "_pom_line_key", createPomLineKey());

        if (overlay) {
          event.preventDefault();
          event.stopImmediatePropagation();

          saveOverlayPositionToCart(overlay);

          try {
            await attachMergedPreviewImageToForm(form);
          } catch (error) {
            console.error("Preview image merge failed:", error);
          }

          // Selections may have changed while the preview image was generated.
          if (!window.ProductOptionsManagerSyncCartForm(form)) return;
          form.submit();
        }
      }, true);
    });
  }

  function getCartPropertyInput(form, key) {
    const escapedKey =
      window.CSS && typeof window.CSS.escape === "function"
        ? window.CSS.escape(key)
        : key.replace(/"/g, '\\"');

    return form.querySelector(`[name="properties[${escapedKey}]"]`);
  }

  function setCartProperty(form, key, value) {
    let input = getCartPropertyInput(form, key);

    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = `properties[${key}]`;
      form.appendChild(input);
    }

    input.value = String(value);
  }

  function removeCartProperty(form, key) {
    const input = getCartPropertyInput(form, key);

    if (input) input.remove();
  }

  function syncVariationPriceProperties(form) {
    const propertyKeys = [
      "_pom_price_source",
      "_pom_final_price",
      "_pom_unit_price",
      "_pom_selected_quantity",
      "_pom_line_key",
    ];

    if (
      !currentPricing.hasExactVariationPrice ||
      !Number.isFinite(currentPricing.unitPrice) ||
      currentPricing.unitPrice <= 0
    ) {
      propertyKeys.forEach((key) => removeCartProperty(form, key));
      return;
    }

    // Informational metadata and quantity locking only. Shopify's variant price
    // is the source of truth; no property activates a cart price override.
    setCartProperty(form, "_pom_price_source", "native_variant");
    setCartProperty(form, "_pom_final_price", currentPricing.finalPrice);
    setCartProperty(form, "_pom_unit_price", currentPricing.unitPrice);
    setCartProperty(form, "_pom_selected_quantity", selectedQuantity);
  }

  function syncCartFormQuantity(form) {
    let input = form.querySelector("[name='quantity']");

    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = "quantity";
      form.appendChild(input);
    }

    input.value = String(Math.max(1, Number(selectedQuantity || 1)));
  }

  function syncAllCartFormsQuantity() {
    document.querySelectorAll("form[action*='/cart/add']").forEach((form) => {
      syncCartFormQuantity(form);
    });
  }

  window.ProductOptionsManagerSyncCartForm = function (form) {
    if (!form) return false;
    if (optionsLoaded && !hasOptionGroups) return true;
    if (!validateRequiredFields({ showErrors: true })) {
      showPricingError();
      return false;
    }

    syncCartFormNativeVariant(form);
    syncVariationPriceProperties(form);
    syncCartFormQuantity(form);
    setCartProperty(form, "_pom_line_key", createPomLineKey());
    return true;
  };

  function createPomLineKey() {
    const randomPart =
      window.crypto && typeof window.crypto.randomUUID === "function"
        ? window.crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`;

    return `${selectedQuantity}-${currentPricing.finalPrice || 0}-${randomPart}`;
  }

  function syncAllCartFormsVariationPriceProperties() {
    document.querySelectorAll("form[action*='/cart/add']").forEach((form) => {
      syncVariationPriceProperties(form);
    });
  }

  async function init() {
    if (nativeVariantData?.variants?.length > 1) {
      document.body.classList.add("pom-native-pricing-active");
    }
    root.innerHTML = `<div class="pom-loading">Loading options...</div>`;
    attachToCartForm();
    validateRequiredFields();

    const data = await loadOptions();

    root.innerHTML = "";
    variationPriceRows.length = 0;

    if (!data.groups || data.groups.length === 0) {
      optionsLoaded = true;
      validateRequiredFields();
      root.style.display = "none";
      return;
    }

    hasOptionGroups = true;
    data.groups.forEach((group) => {
      const groupEl = document.createElement("div");

      groupEl.className = "pom-group";

      group.fields.forEach((field) => {
        if (isVariationPriceStorageField(field)) {
          variationPriceRows.push(
            ...normalizeVariationPriceRows(field.config?.prices),
          );
          return;
        }

        if (normalizeType(field.type) === LEGACY_VARIATION_PRICE_TYPE) {
          return;
        }

        const fieldEl = renderField(field);

        if (!fieldEl) return;

        groupEl.appendChild(fieldEl);
      });

      root.appendChild(groupEl);
    });

    optionsLoaded = true;
    attachToCartForm();
    updatePrice();
    validateRequiredFields();
  }

  async function loadOptions() {
    const embedded = document.querySelector("script[data-pom-options]");
    if (embedded) {
      try {
        const data = JSON.parse(embedded.textContent || "null");
        if (data?.schemaVersion === 1 && data.productId === productGid && Array.isArray(data.groups)) return data;
      } catch (error) {
        console.warn("Embedded product options are invalid", error);
      }
    }
    let lastError;
    for (let attempt = 0; attempt < 3; attempt += 1) {
      const controller = new AbortController();
      let timer;
      try {
        return await Promise.race([
          (async () => {
            const response = await fetch(`/apps/product-options?productId=${encodeURIComponent(productGid)}&handle=${encodeURIComponent(productHandle)}`, { signal: controller.signal });
            if (!response.ok) throw new Error(`Options request failed (${response.status})`);
            const data = await response.json();
            if (!Array.isArray(data?.groups)) throw new Error("Invalid product options response.");
            return data;
          })(),
          new Promise((_, reject) => {
            timer = setTimeout(() => {
              reject(new Error("Product options request timed out."));
              controller.abort();
            }, 12000);
          }),
        ]);
      } catch (error) { lastError = error; }
      finally { clearTimeout(timer); }
    }
    throw lastError;
  }

  function showLoadError(error) {
    console.error("Product options error:", error);
    optionsLoaded = false;
    validateRequiredFields();
    root.innerHTML = "";
    const message = document.createElement("p");
    message.className = "pom-error";
    message.setAttribute("role", "alert");
    message.textContent = "Product options could not be loaded. Please try again.";
    root.appendChild(message);
    const retry = document.createElement("button");
    retry.type = "button";
    retry.className = "pom-option-button";
    retry.textContent = "Retry loading options";
    retry.addEventListener("click", () => init().catch(showLoadError));
    root.appendChild(retry);
  }

  init().catch(showLoadError);
})();
